import React from 'react';
import Cropper from 'react-easy-crop';

export default function Crop({ src, onChange, aspect = 16 / 9 }) {
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [zoom, setZoom] = React.useState(1);

  const onCropComplete = React.useCallback((croppedArea, croppedAreaPixels) => {
    onChange(croppedAreaPixels);
  }, []);

  return (
    <Cropper
      zoom={zoom}
      onZoomChange={setZoom}
      image={src}
      crop={crop}
      aspect={aspect}
      onCropChange={setCrop}
      onCropComplete={onCropComplete}
    />
  );
}
